import { render, staticRenderFns } from "./BulkDeleteModal.vue?vue&type=template&id=740cc76f&"
import script from "./BulkDeleteModal.vue?vue&type=script&lang=js&"
export * from "./BulkDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports